/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_Live_BodyInputs */

const en_hood_live_body = /** @type {(inputs: Hood_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A change reaches every screen that shows it, as it happens.`)
};

/**
* | output |
* | --- |
* | "A change reaches every screen that shows it, as it happens." |
*
* @param {Hood_Live_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_live_body = /** @type {((inputs?: Hood_Live_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_Live_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_live_body(inputs)
});